var DisplayConflicts, DisplayContentTrans, addDisplayData, addSubQuestionToMap, addSubQuestions, arrayContains, breakString, checkField, checkQuestion, checkRowID, checkSubQuestions, clearDisplay, columns, createMarker, crossTabulate, crossTabulationWindow, current_poi_id, current_row_id, data, deleteInstance, deleteOldPois, disableDivs, displayBack, display_data, fc, getAc, getDisplayPartOfContent, getDisplayTableContent, getFormattedText, getInstancePartofJSON, getMonth, getPartOfJSON, getSubQuestion, getSubText, hideSq, loadPartOfData, loadingObjects, part_of_Questions, processData, processInstance, removeAllPOIItems, removePOIItem, renderImage, renderSq, renderSubQuestionAns, renderSubQuestions, showConflicts, showSq, sqPadding, sqPaddingText, switchLayout, tableQuestions, tempDataStore, viewConflicts;

display_data = new Array;

fc = 0;

part_of_Questions = new Array;

tableQuestions = new Array;

current_poi_id = null;

current_row_id = null;

data = [];

columns = [];

fc = 0;

sqPadding = '&nbsp;&nbsp;&nbsp;';

sqPaddingText = '&nbsp;&nbsp;&nbsp;';

loadingObjects = new Array;

tempDataStore = void 0;

crossTabulationWindow = void 0;

deleteOldPois = function(old, newIds, id) {
  var delKey, delNewKey, ids, key;
  ids = POI[id].instance.ids;
  for (key in old) {
    delKey = arrayContains(ids, old[key]);
    delNewKey = arrayContains(newIds, delKey);
    if (delNewKey === -1) {
      deleteInstance(id, delKey);
    }
  }
};

deleteInstance = function(id, key) {
  delete POI[id].instance.name[key];
  delete POI[id].instance.locations[key];
  delete POI[id].instance.loadedLocs[key];
  delete POI[id].instance.dates[key];
  delete POI[id].instance.coordinates[key];
  delete display_data[key];
};

arrayContains = function(array, value) {
  var key;
  for (key in array) {
    if (array[key] === value) {
      return key;
    }
  }
  return -1;
};

checkSubQuestions = function(question, currentQuestion, page) {
  var action, listitem, p, subQ, subQuestions, subq, subquestions, t, tempTV, tv, tvs;
  if (currentQuestion.triggerValues !== void 0) {
    tvs = currentQuestion.triggerValues;
    tv = tvs.triggerValue;
    if (tv !== null) {
      t = 0;
      while (t < tv.length) {
        subQuestions = Array();
        tempTV = tv[t];
        action = tempTV.action;
        if (action !== null) {
          subQ = action.subQuestions;
          if (subQ === void 0) {
            t++;
            continue;
          }
          subquestions = subQ.question;
          p = 0;
          while (p < subquestions.length) {
            subq = new Questions;
            subq.id = subquestions[p].id;
            subq.text = subquestions[p].text;
            subq.type = subquestions[p].type;
            subq.optional = subquestions[p].optional;
            subq.inVisible = subquestions[p].inVisible;
            if (subquestions[p].listItems !== void 0) {
              listitem = subquestions[p].listItems.listItem;
              subq.options = listitem;
            }
            subQuestions[p] = subq;
            if (checkQType(subquestions[p].type) && (!subquestions[p].inVisible || subquestions[p].type === 'Location1Question' || subquestions[p].type === 'Location2Question' || subquestions[p].type === 'Location3Question' || subquestions[p].type === 'Location4Question')) {
              page.fieldsID[fc] = subquestions[p].id;
              page.fieldsName[fc] = subquestions[p].text;
              fc++;
            }
            checkSubQuestions(subq, subq, page);
            p++;
          }
        } else {

        }
        question.action[tv[t].value] = subQuestions;
        t++;
      }
    } else {

    }
  } else {

  }
};

processData = function(data) {
  async.each(data, saveFile, function(err) {});
};

processInstance = function(instance) {
  var i, lname, p;
  i = 0;
  while (i < instance.questionList.length) {
    if (answers[id].questionList[i].answers[j][0] === null) {
      setValue('  -  ', answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
    } else if (answers[id].questionList[i].answers[j][0] === true) {
      setValue('Yes', answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
    } else if (answers[id].questionList[i].answers[j][0] === false) {
      setValue('No', answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
    } else if (answers[id].questionList[i].fieldName === 'Location1' || answers[id].questionList[i].fieldName === 'Location2' || answers[id].questionList[i].fieldName === 'Location3' || answers[id].questionList[i].fieldName === 'Location4') {
      lname = getLocationName(answers[id].questionList[i].answers[j][0]);
      setValue(lname, answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
    } else if (answers[id].questionList[i].fieldName === 'modified') {
      setValue(answers[id].questionList[i].answers[j][0], answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
    } else if (answers[id].questionList[i].fieldName === 'user_id') {
      POI[id].instance.editor_id[answers[id].questionList[i].answers[j][1]] = answers[id].questionList[i].answers[j][0];
      setValue(users_name[answers[id].questionList[i].answers[j][0]], answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
    } else if (answers[id].questionList[i].fieldName === 'Coordinates') {
      if (answers[id].questionList[i].answers[j][0] !== void 0) {
        p = getCoordinates(answers[id].questionList[i].answers[j][0]);
        setValue(p[1].replace(' ', '') + ' ' + p[0], answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
      }
    } else {
      setValue(answers[id].questionList[i].answers[j][0], answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
    }
    ac++;
    i++;
  }
};

loadPartOfData = function(id, parent, instance) {
  var json;
  return;
  json = '';
  if (instance) {
    json = getInstancePartofJSON(id, parent);
  } else {
    json = getPartOfJSON(id, parent);
  }
  if (json === '') {
    return;
  }
  $.ajax({
    type: 'POST',
    url: baseUrl + 'app/answers/partof/' + POI[id].answerTable + '/' + readOnlyOwn + '/' + groupID + '/' + userID + '/0',
    data: json,
    async: true,
    headers: {
      'Content-Type': 'application/json',
      'userid': userName,
      'key': pwrd
    },
    success: function(result) {
      answers[id] = result;
    },
    error: function(xhr) {
      closeProgress();
    },
    complete: function() {
      var fc;
      var ac, i, iN, j, lname, p, rid, temp, url;
      fc = 0;
      ac = 0;
      if (answers[id] === void 0) {
        closeProgress();
        return;
      } else {

      }
      if (answers[id].questionList[0].answers === void 0) {
        closeProgress();
        return;
      }
      j = 0;
      while (j < answers[id].questionList[0].answers.length) {
        i = 0;
        while (i < answers[id].questionList.length) {
          fc = getAc(answers[id].questionList[i].answers[j][1], id);
          if (answers[id].questionList[i].answers[j][0] === null) {
            setValue('  -  ', answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
          } else if (answers[id].questionList[i].answers[j][0] === true) {
            setValue('Yes', answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
          } else if (answers[id].questionList[i].answers[j][0] === false) {
            setValue('No', answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
          } else if (answers[id].questionList[i].fieldName === 'Location1' || answers[id].questionList[i].fieldName === 'Location2' || answers[id].questionList[i].fieldName === 'Location3' || answers[id].questionList[i].fieldName === 'Location4') {
            lname = getLocationName(answers[id].questionList[i].answers[j][0]);
            setValue(lname, answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
          } else if (answers[id].questionList[i].fieldName === 'user_id') {
            POI[id].instance.editor_id[answers[id].questionList[i].answers[j][1]] = answers[id].questionList[i].answers[j][0];
            setValue(users_name[answers[id].questionList[i].answers[j][0]], answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
          } else if (answers[id].questionList[i].fieldName === 'Coordinates') {
            if (answers[id].questionList[i].answers[j][0] !== void 0) {
              p = getCoordinates(answers[id].questionList[i].answers[j][0]);
              setValue(p[0].replace(' ', '') + ' ' + p[1].replace(' ', ''), answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
            }
          } else {
            setValue(answers[id].questionList[i].answers[j][0], answers[id].questionList[i].fieldName, id, answers[id].questionList[i].answers[j][1]);
            ac++;
          }
          i++;
        }
        ac = 0;
        fc++;
        j++;
      }
      if (!divsLoaded) {

      } else {

      }
      if (answers[id].imageNo) {
        j = 0;
        while (answers[id].imageNo !== void 0 && j < answers[id].imageNo.length) {
          rid = answers[id].imageNo[j][0];
          iN = answers[id].imageNo[j][1];
          url = null;
          if (answers[id].imageNo[j][3]) {
            url = answers[id].imageNo[j][3];
          }
          if (!POI[id].instance.imageNo[rid]) {
            POI[id].instance.imageNo[rid] = [];
          }
          temp = [];
          temp.push(iN);
          temp.push(url);
          temp.push(answers[id].imageNo[j][2]);
          POI[id].instance.imageNo[rid].push(temp);
          j++;
        }
      }
      applyLocationFilterNew(id);
    }
  });
};


/**
	@description : Gets the Subquestion question Object from a given question.
	If the question does not have the given subquestioin, return null.
 */

getSubQuestion = function(question, subquestionID) {
  var i, j, opt, sq, subQ;
  i = 0;
  while (i < question.options.length) {
    opt = question.options[i];
    if (question.action[opt] !== void 0) {
      subQ = question.action[opt];
      j = 0;
      while (j < subQ.length) {
        if (subQ[j].id === subquestionID) {
          return subQ[j];
        } else {
          if (subQ[j].hasSubquestions === true) {
            sq = getSubQuestion(subQ[j], subquestionID);
            if (sq !== null) {
              return sq;
            }
          }
        }
        j++;
      }
    }
    i++;
  }
  return null;
};

switchLayout = function(id) {
  var objPOI;
  objPOI = getPOIByID(id);
  if (objPOI.layout === 'rows') {
    objPOI.layout = 'columns';
    DisplayContentTrans(id);
  } else if (objPOI.layout === 'columns') {
    objPOI.layout = 'rows';
    DisplayContent(id);
  }
};

showConflicts = function(id, rowid, pof, back) {
  loadHistory(id, rowid, pof, back, true);
};

viewConflicts = function(rowid, id) {
  $('#conflict-dialog').dialog('option', 'height', 'auto');
  $('#conflict-dialog').dialog('option', 'modal', false);
  $('#conflict-dialog').dialog('option', 'width', 600);
  $('#conflict-dialog').dialog('option', 'height', 450);
  $('#conflict-dialog').dialog('open');
  $('#conflict-dialog').dialog('option', 'position', [660, 160]);
  DisplayConflicts(rowid, id);
  $('#tableconflict').dialog('option', 'width', 600);
  $('#tableconflict').dialog('option', 'height', 400);
};


/**
  * @description : This function displays the Table for a the Form Type with the given id
  * @param id : the "id" of Form type to be displayed.
 */

DisplayContentTrans = function(id) {
  var columns;
  var i;
  var key;
  var columnSet, columnsArray, dataAvailable, divsLoaded, first, firstArray, html, i, k, key, locid, objPOI, qn, sqText, sub, tempData, title, value;
  if (!divsLoaded) {
    createDivs();
    divsLoaded = true;
  }
  objPOI = getPOIByID(id);
  columns = [];
  columnSet = [];
  first = [];
  firstArray = [];
  columnsArray = [];
  dataAvailable = void 0;
  showProgress();
  $('#ft' + id)[0].style.cssText = 'margin-bottom:20px;';
  $('#Forms')[0].style.cssText = '';
  $('#tabView').hide();
  if ($('#ft' + id).html() !== '') {
    $('#ft' + id).html('');
  }
  html = '<div class=\'alt1\'><div class=\'tableLayoutRows\'><div class=\'hidden\' id=\'tableLayout\'><img src=\'' + image_res + 'table_column.png\'></div><b>' + objPOI.name + '</b> <!--<a class=\'button-grey\' onclick=\'crossTabulate(' + id + ')\'>Crosstabulate</a>--> </div></div><div id=\'table_' + id + '\' style=\'min-height:300px; max-height: 600px; over-flow: auto;\'></div>';
  tempDataStore = new dojo.store.Memory({
    data: []
  });
  first[0] = {
    'label': 'Name',
    'field': 'name',
    'width': '80px'
  };
  firstArray[0] = first;
  i = 0;
  for (key in objPOI.instance.name) {
    if (selectedAnswersCollection.get(key) === null) {
      j++;
      continue;
    }
    title = objPOI.instance.name[key] === '' ? '-' : objPOI.instance.name[key];
    columns[i] = {
      'label': title,
      'field': key,
      'width': '80px',
      'formatter': formatText
    };
    dataAvailable = true;
    i++;
  }
  columnSet[0] = firstArray;
  columnsArray[0] = columns;
  columnSet[1] = columnsArray;
  i = 0;
  while (i < objPOI.instance.pages.length) {
    if (!dataAvailable) {

    } else {
      k = 0;
      while (k < objPOI.instance.pages[i].questions.length) {
        qn = objPOI.instance.pages[i].questions[k];
        tempData = {};
        if (qn.inVisible || !checkQTypeDisplay(qn.type)) {
          if (qn.type !== 'NameQuestion' && qn.id !== 'modified' && qn.id !== 'Location1' && qn.id !== 'Location2' && qn.id !== 'Location3' && qn.id !== 'Location4' && qn.id !== 'portalEditTime' && qn.id !== 'phoneEditTime' && qn.id !== 'entryTime' && qn.id !== 'user_id') {
            k++;
            continue;
          }
        }
        if (objPOI.instance.pages[i].questions[k].id === 'Name') {
          k++;
          continue;
        }
        sqText = '';
        if (qn.hasSubquestions) {
          sqText = ' hasSubquestion ';
        }
        if (qn.id === 'Location1' || qn.id === 'Location2' || qn.id === 'Location3' || qn.id === 'Location4') {
          locid = qn.id.substring(8, 9) - 1;
          if (locationLabels[locid] !== void 0) {
            tempData['name'] = locationLabels[locid];
          }
        } else {
          tempData['name'] = qn.text;
        }
        for (key in objPOI.instance.name) {
          if (selectedAnswersCollection.get(key) === null) {
            k++;
            continue;
          }
          sqText = '';
          if (qn.hasSubquestions) {
            sqText = ' class=\'pointer\' onclick=\'FormView(' + id + ', ' + key + ', -1, 2)\'';
          }
          value = '';
          if (qn.type === 'Part_of_Question') {
            value += '<a class=\'pofData\' id=\'' + key + '\' name=\'' + getPOIId(qn.relations[0].ref) + '\' back=\'1\'>Show Part Of Data</a>';
          } else if (qn.type === 'TableQuestion') {
            value += '<a class=\'tableData\' id=\'' + key + '\' name=\'' + getPOIId(qn.table.columns.ref) + '\'>Show table data</a>';
          } else if (qn.ans[key] === null || qn.ans[key] === void 0) {
            value += '   -   ';
          } else if (qn.ans[key] === true && qn.ans[key] !== 1) {
            value += ' Yes ';
          } else if (qn.ans[key] === false && qn.ans[key] !== 0) {
            value += ' No ';
          } else {
            if (qn.ans[key].length > 50) {
              sub = qn.ans[key].substring(0, 50);
              value += sub + ' <a onclick="readMore(\'' + qn.text.trim() + '\',\'' + qn.ans[key].trim() + '\')">read more...</a>';
            } else {
              value += qn.ans[key];
            }
          }
          tempData[key] = value;
        }
        tempDataStore.put(tempData);
        k++;
      }
    }
    i++;
  }
  if (dataAvailable) {
    $('#ft' + id).html(html);
    addTable('table_' + id, tempDataStore, columnSet, id);
  }
  closeProgress();
};

DisplayConflicts = function(rowid, id, obj) {
  var columns;
  var i;
  var key;
  var columnSet, columnsArray, dataAvailable, divsLoaded, first, firstArray, history, html, i, k, key, objPOI, qn, sqText, tempData, value;
  if (!divsLoaded) {
    createDivs();
    divsLoaded = true;
  }
  objPOI = getPOIByID(id);
  columns = [];
  columnSet = [];
  first = [];
  firstArray = [];
  columnsArray = [];
  dataAvailable = void 0;
  history = objPOI.instance.old[rowid];
  showProgress();
  html = '<div class=\'alt1\'><b>' + objPOI.name + '</b></div><div id=\'tableconflict\' style=\'height:300px; max-height: 300px;width:500px; max-width: 500px; over-flow: auto;\'></div>';
  tempDataStore = new dojo.store.Memory({
    data: []
  });
  first[0] = {
    'label': 'Name',
    'field': 'name',
    'width': '40px'
  };
  firstArray[0] = first;
  i = 0;
  for (key in history) {
    if (objPOI.instance.pages[0].questions[0].ans[history[key]] === 1) {
      columns[i] = {
        'label': objPOI.instance.name[history[key]],
        'field': history[key],
        'width': '40px',
        'formatter': formatText
      };
      dataAvailable = true;
      i++;
    }
  }
  columns[i] = {
    'label': objPOI.instance.name[rowid],
    'field': rowid,
    'width': '40px',
    'formatter': formatText
  };
  columnSet[0] = firstArray;
  columnsArray[0] = columns;
  columnSet[1] = columnsArray;
  i = 0;
  while (i < objPOI.instance.pages.length) {
    if (!dataAvailable) {

    } else {
      k = 0;
      while (k < objPOI.instance.pages[i].questions.length) {
        qn = objPOI.instance.pages[i].questions[k];
        tempData = {};
        if (qn.inVisible || !checkQTypeDisplay(qn.type)) {
          if (qn.type !== 'NameQuestion' && qn.id !== 'modified' && qn.id !== 'Location1' && qn.id !== 'Location2' && qn.id !== 'Location3' && qn.id !== 'Location4' && qn.id !== 'portalEditTime' && qn.id !== 'phoneEditTime' && qn.id !== 'entryTime' && qn.id !== 'user_id') {
            k++;
            continue;
          }
        }
        if (objPOI.instance.pages[i].questions[k].id === 'Name') {
          k++;
          continue;
        }
        sqText = '';
        if (qn.hasSubquestions) {
          sqText = ' hasSubquestion ';
        }
        tempData['name'] = qn.text;
        for (key in history) {
          sqText = '';
          if (qn.hasSubquestions) {
            sqText = ' class=\'pointer\' onclick=\'FormView(' + id + ', ' + key + ', -1, 2)\'';
          }
          value = '';
          if (qn.type === 'Part_of_Question') {
            value += '<a class=\'pofData\' id=\'' + history[key] + '\' name=\'' + getPOIId(qn.relations[0].ref) + '\' back=\'1\'>Show Part Of Data</a>';
          } else if (qn.type === 'TableQuestion') {
            value += '<a class=\'tableData\' id=\'' + key + '\' name=\'' + getPOIId(qn.table.columns.ref) + '\'>Show table data</a>';
          } else if (qn.ans[history[key]] === null || qn.ans[history[key]] === void 0) {
            value += '   -   ';
          } else if (qn.ans[history[key]] === true && qn.ans[history[key]] !== 1) {
            value += ' Yes ';
          } else if (qn.ans[history[key]] === false && qn.ans[history[key]] !== 0) {
            value += ' No ';
          } else {
            value += qn.ans[history[key]];
          }
          tempData[history[key]] = value;
        }
        value = '';
        if (qn.type === 'Part_of_Question') {
          value += '<a class=\'pofData\' id=\'' + history[key] + '\' name=\'' + getPOIId(qn.relations[0].ref) + '\' back=\'1\'>Show Part Of Data</a>';
        } else if (qn.type === 'TableQuestion') {
          value += '<a class=\'tableData\' id=\'' + key + '\' name=\'' + getPOIId(qn.table.columns.ref) + '\'>Show table data</a>';
        } else if (qn.ans[rowid] === null || qn.ans[rowid] === void 0) {
          value += '   -   ';
        } else if (qn.ans[rowid] === true && qn.ans[rowid] !== 1) {
          value += ' Yes ';
        } else if (qn.ans[rowid] === false && qn.ans[rowid] !== 0) {
          value += ' No ';
        } else {
          value += qn.ans[rowid];
        }
        tempData[rowid] = value;
        tempDataStore.put(tempData);
        k++;
      }
    }
    i++;
  }
  if (dataAvailable) {
    $('#conflictdata').html(html);
    addTable('tableconflict', tempDataStore, columnSet, id);
  }
  closeProgress();
};

getFormattedText = function(text) {
  var i, length, nl, p1, p2;
  length = text.length;
  nl = length / 30 + 1;
  i = 0;
  while (i < nl) {
    i++;
  }
  if (text.length > 30) {
    p1 = text.substr(0, 12);
    p2 = text.substr(12, text.length);
    return p1 + '<br/>' + p2;
  }
  return text;
};

breakString = function(text, maxLength) {
  var i, length, li, nl, ret, sub, tl;
  if (text === void 0) {
    return '';
  }
  length = text.length;
  if (length <= maxLength) {
    return text;
  }
  nl = maxLength;
  i = 0;
  ret = '';
  while (i < length) {
    sub = text.substring(i, nl);
    tl = sub.length;
    if (sub.charAt(tl - 1) !== ' ') {
      li = sub.lastIndexOf(' ');
      if (li === -1) {
        li = maxLength;
      }
      ret += sub.substring(0, li);
      ret += '<br/>';
      i = i + li + 1;
      nl = nl + li + 1;
    } else {
      ret += sub;
      ret += '<br/>';
      i = i + maxLength;
      nl = nl + maxLength;
    }
  }
  return ret;
};

getSubText = function(text) {
  var p1, p2, si;
  if (text.length > 30) {
    si = text.lastIndexOf(' ');
    p1 = text.substr(0, 12);
    p2 = text.substr(12, text.length);
    return p1 + '<br/>' + p2;
  }
};

getDisplayPartOfContent = function(id, parentId, back) {
  var fc;
  var i;
  var key;
  var key;
  var formNo, html, i, k, key, objPOI, qn, sq;
  objPOI = getPOIByID(id);
  if (objPOI === void 0) {
    return '';
  }
  html = '<div class=alt1><b>' + objPOI.name + '</b>';
  html += '<div class=pgnum-out>';
  i = 0;
  while (i < objPOI.instance.pages.length) {
    html += '<div class=pgnumber>';
    html += '</div>';
    i++;
  }
  html += '</div></div>';
  html += '<div class=\'tblscrl\'><table id=tab' + id + ' class=tblout border=\'0\' cellspacing=\'0\' cellpadding=\'0\'>';
  html += '<tr class=alt3><td></td>';
  for (key in objPOI.instance.row_id1) {
    if (objPOI.instance.row_id1[key] === parentId) {
      html += '<td  style=cursor:pointer; ><b><u>' + objPOI.instance.name[key] + '</u></b></td>';
    }
  }
  html += '</tr>';
  fc = 0;
  i = 0;
  while (i < objPOI.instance.pages.length) {
    if (i === 0) {
      html += '<tr id=pHead' + id + 'p' + objPOI.instance.pages[i].number + '><td colspan=' + objPOI.instance.name.length + 1 + '>' + '<div  id=' + id + 'p' + objPOI.instance.pages[i].number + ' class=pchk1><div id=divPg' + id + ' class=\'pgtitle fm\' style=\'cursor:pointer;\'><span class=\'ico01\'></span>' + objPOI.instance.pages[i].name + '</div></div></td></tr>';
      html += '<span id=pDetails' + id + 'p' + objPOI.instance.pages[i].number + '>';
    } else {
      html += '<tr style=\'display:none;\' id=pHead' + id + 'p' + objPOI.instance.pages[i].number + '><td colspan=' + objPOI.instance.name.length + 1 + '>' + '<div  id=' + id + 'p' + objPOI.instance.pages[i].number + ' class=pchk1><div id=divPg' + id + ' class=\'pgtitle fm\' style=\'cursor:pointer;\'><span class=\'ico01\'></span>' + objPOI.instance.pages[i].name + '</div></div></td></tr>';
      html += '<span style=\'display:none;\' id=pDetails' + id + 'p' + objPOI.instance.pages[i].number + '>';
    }
    k = 0;
    while (k < objPOI.instance.pages[i].questions.length) {
      qn = objPOI.instance.pages[i].questions[k];
      if (qn.inVisible || !checkQTypeDisplay(qn.type)) {
        k++;
        continue;
      }
      html += '<tr id=' + id + 'p' + objPOI.instance.pages[i].number + 'r' + k + ' class=alt4>';
      if (qn.hasSubquestions === true) {
        html += '<tr id=' + id + 'p' + objPOI.instance.pages[i].number + 'r' + k + ' class=\'' + qn.id + ' parentQuestionCollapsed\' onclick="showSq(\'' + qn.id + '_subquestion\')">';
      } else {
        html += '<tr id=' + id + 'p' + objPOI.instance.pages[i].number + 'r' + k + ' class=alt4>';
      }
      html += '<td class=lft><b>' + qn.text + '</td></td>';
      if (qn.type === 'Part_of_Question') {
        for (key in objPOI.instance.name) {
          if (display_data[key] !== true) {
            k++;
            continue;
          }
          html += '<td><a href=\'#\' class=\'pofData\' id=\'' + key + '\' name=\'\' back=\'2\'>Show Part Of Data</a></td>';
        }
      }
      formNo = '';
      for (key in objPOI.instance.row_id1) {
        if (objPOI.instance.row_id1[key] === parentId) {
          formNo = key;
          if (objPOI.instance.pages[i].questions[k].type === 'Part_of_Question') {
            html += '<td><a href=\'#\' id=\'pofData\' name=\'' + key + '\'>Show Part Of Data</a></td>';
          } else if (objPOI.instance.pages[i].questions[k].ans[key] === null) {
            html += '<td>' + '   -   ' + '</td>';
          } else if (objPOI.instance.pages[i].questions[k].ans[key] === true) {
            html += '<td>' + ' Yes ' + '</td>';
          } else if (objPOI.instance.pages[i].questions[k].ans[key] === false) {
            html += '<td>' + ' No ' + '</td>';
          } else {
            html += '<td>' + objPOI.instance.pages[i].questions[k].ans[key] + '</td>';
          }
        }
      }
      html += '</tr>';
      if (qn.hasSubquestions === true) {
        sq = renderSq(qn, formNo);
        html += sq;
      }
      k++;
    }
    i++;
  }
  html += '</table></div>';
  return html;
};


/**
  * @description : Creates Table content display
  * @param id : The parent POI ID
  * @param parentId : The POI ID of the parent Questionnaire
  *
 */

getDisplayTableContent = function(id, parentId, firstPage) {
  var i;
  var qn;
  var x;
  var html, i, j, key, list, objPOI, opt, qn, x;
  return;
  objPOI = getPOIByID(id);
  html = '';
  html += '<div class=\'displayQuestionDiv\' style=\'max-width: 100%; width: 100%; overflow-x: scroll;\'><div id=\'' + id + '_toparea\'><b>' + objPOI.name + '</b> </div><table id=tab' + id + ' class=tblout border=\'0\' cellspacing=\'0\' cellpadding=\'0\'>';
  html += '<tr class=alt3><td></td>';
  i = 0;
  while (i < objPOI.instance.questions.length) {
    qn = objPOI.instance.questions[i];
    if (qn.inVisible || !checkQTypeDisplay(qn.type)) {
      i++;
      continue;
    }
    html += '<td  style=cursor:pointer; ><b><u>' + qn.text + '</u></b></td>';
    i++;
  }
  if (tableRows[objPOI.identifier] === void 0 || tableRows[objPOI.identifier].length === 0) {
    html += '<td></td>';
  }
  html += '</tr>';
  j = 0;
  for (key in objPOI.instance.row_id1) {
    if (objPOI.instance.row_id1[key] === parentId) {
      html += '<tr id=' + id + 'p' + 'r' + j + ' class=alt4>';
      if (tableRows[objPOI.identifier] === void 0 || tableRows[objPOI.identifier].length === 0) {
        html += '<td class=lft><b>' + j + 1 + '</td></td>';
      } else {
        html += '<td class=lft><b>' + tableRows[objPOI.identifier][j] + '</td></td>';
      }
      i = 0;
      while (i < objPOI.instance.questions.length) {
        qn = objPOI.instance.questions[i];
        if (qn.id === 'ID') {
          html += '<input type=\'hidden\' id=\'data' + id + qn.id + '' + j + '\' value=\'' + qn.ans[key] + '\'/>';
        }
        if (qn.inVisible || !checkQTypeDisplay(qn.type)) {
          i++;
          continue;
        }
        if (qn.type === 'Part_of_Question') {
          html += '<td><a href=\'#\' id=\'pofData\' name=\'' + key + '\'>Show Part Of Data</a></td>';
        } else if (qn.type === 'DateQuestion') {
          html += '<td><input type=\'date\'  name=\'' + id + qn.id + '\' id=\'' + id + qn.id + '' + j + '\' value=\'' + qn.ans[key] + '\' readonly/></td>';
        } else if (qn.type === 'TimeOfDayQuestion') {
          html += '<td><input type=\'time\'  name=\'' + id + qn.id + '\' id=\'' + id + qn.id + '' + j + '\' value=\'' + qn.ans[key] + '\' readonly/></td>';
        } else if (qn.type === 'SelectOneQuestion') {
          html += '<td><div class="radio">';
          x = 0;
          while (x < qn.options.length) {
            opt = qn.options[x];
            html += '<input ';
            if (firstPage) {
              html += ' class="' + id + qn.id + '" name="' + qn.id + '' + j + '"  id="' + id + qn.id + '' + j + '' + x + '" ';
            } else {
              html += ' name="_' + qn.id + '' + j + '"  id="_' + id + qn.id + '' + j + '' + x + '" ';
            }
            html += ' type="radio"  ';
            html += 'disabled="true" value="' + opt + '"';
            if (trim1(qn.ans[key]) === trim1(opt)) {
              html += ' checked ';
            }
            html += '/>' + opt + '<br/>';
            x++;
          }
          html += '</div>';
        } else if (qn.validationlist !== void 0 && qn.validationlist.length > 0) {
          html += '<td><select name=\'' + id + qn.id + '\' id=\'' + id + qn.id + '' + j + '\' disabled=\'true\'><option value=\'\'></option>';
          list = qn.validationlist;
          x = 0;
          while (x < list.length) {
            html += '<option value=\'' + list[x] + '\'';
            if (qn.ans[key] === list[x]) {
              html += ' selected ';
            }
            html += '>' + list[x] + '</option>';
            x++;
          }
          html += '</select>';
        } else {
          html += '<td><input type=\'text\' name=\'' + id + qn.id + '\' id=\'' + id + qn.id + '' + j + '\' value=\'' + qn.ans[key] + '\' readonly/></td>';
        }
        i++;
      }
      if (tableRows[objPOI.identifier] === void 0 || tableRows[objPOI.identifier].length === 0) {
        html += '<td></td>';
      }
      html += '</tr>';
      j++;
    }
  }
  html += '</table></div>';
  return html;
};

showSq = function(id, parent) {
  if ($('.' + id).hasClass('hiddensq')) {
    $('.' + id).removeClass('hiddensq');
    $('.' + parent).removeClass('parentQuestionCollapsed');
    $('.' + parent).addClass('parentQuestionExpanded');
    $('.' + id).addClass('shownsq');
    $('.' + id).show();
  } else {
    $('div.' + id).click();
    $('.' + id).removeClass('shownsq');
    $('.' + parent).removeClass('parentQuestionExpanded');
    $('.' + parent).addClass('parentQuestionCollapsed');
    $('.' + id).addClass('hiddensq');
    $('.' + id).hide();
  }
};

hideSq = function() {};

addSubQuestions = function(question) {
  var i, j, json, opt, subQ;
  json = '';
  i = 0;
  while (i < question.options.length) {
    opt = question.options[i];
    if (question.action[opt] !== void 0) {
      subQ = question.action[opt];
      j = 0;
      while (j < subQ.length) {
        if (checkQType(subQ[j].type)) {
          json += ',{"fieldName":"' + subQ[j].id + '"}';
          if (subQ[j].hasSubquestions) {
            json += addSubQuestions(subQ[j]);
          }
        }
        j++;
      }
    }
    i++;
  }
  return json;
};

getInstancePartofJSON = function(id, parentRowId) {
  var i;
  var qn;
  var i, instance, j, json, once, qn;
  if (POI[id] === void 0) {
    return '';
  }
  json = '{  "questionList" : [ ';
  once = false;
  instance = POI[id].instance;
  i = 0;
  while (i < instance.pages.length) {
    j = 0;
    while (j < instance.pages[i].questions.length) {
      qn = instance.pages[i].questions[j];
      if (checkQType(qn.type) && (!qn.inVisible || qn.type === 'Location1Question' || qn.type === 'Location2Question' || qn.type === 'Location3Question' || qn.type === 'Location4Question') || qn.type === 'NameQuestion' || qn.id === 'ID') {
        if (!once) {
          json += '{"fieldName":"' + qn.id + '"}';
          once = true;
        } else {
          json += ',{"fieldName":"' + qn.id + '"}';
        }
      }
      j++;
    }
    i++;
  }
  if (instance.questions !== void 0) {
    i = 0;
    while (i < instance.questions.length) {
      qn = instance.questions[i];
      if (checkQType(qn.type) && (!qn.inVisible || qn.type === 'Location1Question' || qn.type === 'Location2Question' || qn.type === 'Location3Question' || qn.type === 'Location4Question') || qn.type === 'NameQuestion' || qn.id === 'ID') {
        if (!once) {
          json += '{"fieldName":"' + qn.id + '"}';
          once = true;
        } else {
          json += ',{"fieldName":"' + qn.id + '"}';
        }
      }
      i++;
    }
  }
  json += '], "arguments" : [';
  json += '' + parentRowId + '';
  json += ']}';
  return json;
};


/*
  * @description : the function returns the JSON of field names & ids for a given POI
  * @param id : the "id" of a selected POI
 */

getPartOfJSON = function(id, parent) {
  var i;
  var qn;
  var i;
  var i, instance, j, json, key, once, qn;
  if (POI[id] === void 0) {
    return '';
  }
  if (POI[parent] === void 0) {
    return '';
  }
  json = '{  "questionList" : [ ';
  once = false;
  instance = POI[id].instance;
  i = 0;
  while (i < instance.pages.length) {
    j = 0;
    while (j < instance.pages[i].questions.length) {
      qn = instance.pages[i].questions[j];
      if (checkQType(qn.type) && (!qn.inVisible || qn.type === 'Location1Question' || qn.type === 'Location2Question' || qn.type === 'Location3Question' || qn.type === 'Location4Question') || qn.type === 'NameQuestion' || qn.id === 'ID') {
        if (!once) {
          json += '{"fieldName":"' + qn.id + '"}';
          once = true;
        } else {
          json += ',{"fieldName":"' + qn.id + '"}';
        }
      }
      j++;
    }
    i++;
  }
  if (instance.questions !== void 0) {
    i = 0;
    while (i < instance.questions.length) {
      qn = instance.questions[i];
      if (checkQType(qn.type) && (!qn.inVisible || qn.type === 'Location1Question' || qn.type === 'Location2Question' || qn.type === 'Location3Question' || qn.type === 'Location4Question') || qn.type === 'NameQuestion' || qn.id === 'ID') {
        if (!once) {
          json += '{"fieldName":"' + qn.id + '"}';
          once = true;
        } else {
          json += ',{"fieldName":"' + qn.id + '"}';
        }
      }
      i++;
    }
  }
  json += '], "arguments" : [';
  once = false;
  if (POI[parent].instance.name.length === 0) {
    return '';
  }
  for (key in POI[parent].instance.name) {
    if (!once) {
      json += '' + key + '';
      once = true;
    } else {
      json += ',' + key + '';
    }
  }
  i = 0;
  while (i < POI[parent].ques.forms.length) {
    if (!once) {
      json += '' + POI[parent].ques.forms[i].rowId + '';
      once = true;
    } else {
      json += ',' + POI[parent].ques.forms[i].rowId + '';
    }
    i++;
  }
  json += ']}';
  return json;
};


/**
	back : directs which view to show
		1 Map View
		2 Table View
		3 Single Instance View
 */

displayBack = function(pof, back) {};


/* clear the UI of * central pane */

clearDisplay = function() {
  var arr, i;
  arr = getSelectedPOI_ID();
  i = 0;
  while (i < arr.length) {
    $('#ft' + arr[i]).html('');
    i++;
  }
  $('#Forms')[0].style.cssText = '';
  $('#tabView').html('');
};


/* get the month's numeric number */

getMonth = function(mon) {
  if (mon === 'Jan') {
    return '01';
  } else if (mon === 'Feb') {
    return '02';
  } else if (mon === 'Mar') {
    return '03';
  } else if (mon === 'Apr') {
    return '04';
  } else if (mon === 'May') {
    return '05';
  } else if (mon === 'Jun') {
    return '06';
  } else if (mon === 'Jul') {
    return '07';
  } else if (mon === 'Aug') {
    return '08';
  } else if (mon === 'Sep') {
    return '09';
  } else if (mon === 'Oct') {
    return '10';
  } else if (mon === 'Nov') {
    return '11';
  } else if (mon === 'Dec') {
    return '12';
  }
};


/*
	check whether a field belongs to the POI with 'id' (passed onto the function)
 */

checkField = function(id, field) {
  var i, j;
  if (field === 'Name' || field === 'modified') {
    return true;
  }
  i = 0;
  while (i < POI[id].ques.pages.length) {
    j = 0;
    while (j < POI[id].ques.pages[i].fieldsID.length) {
      if (POI[id].ques.pages[i].fieldsID[j] === field) {
        return true;
      }
      j++;
    }
    i++;
  }
  return false;
};

checkQuestion = function(qn) {
  if (checkQType(qn.type) && (!qn.inVisible || qn.type === 'Location1Question' || qn.type === 'Location2Question' || qn.type === 'Location3Question' || qn.type === 'Location4Question') || qn.type === 'NameQuestion' || qn.id === 'modified' || qn.id === 'Area' || qn.id === 'Route') {
    return true;
  }
  return false;
};

createMarker = function(id, key) {
  var data;
  var gm, objPOI, point;
  objPOI = getPOIByID(id);
  data = '';
  data += '<div class=\'infoWindowHeight\'>';
  gm = new genericMarker;
  if (objPOI.instance.coordinates[key] !== void 0) {
    point = objPOI.instance.coordinates[key];
    gm.lat = trim(point.substring(0, point.indexOf(' ')));
    gm.lon = trim(point.substring(point.indexOf(' '), point.length));
  } else {
    gm.lat = 0.0;
    gm.lon = 0.0;
  }
  gm.data = data;
  if (objPOI.smallIcon === void 0 && objPOI.smallIconLink === void 0) {
    gm.smallIcon = '//' + window.location.host + '/icons/static_icons/small/marker_green.png';
  } else if (objPOI.smallIconLink !== void 0) {
    gm.smallIcon = objPOI.smallIconLink;
  } else {
    gm.smallIcon = '//' + window.location.host + '/icons/' + db + '/small/' + objPOI.smallIcon;
  }
  if (objPOI.largeIcon === void 0 && objPOI.smallIconLink === void 0) {
    gm.largeIcon = '//' + window.location.host + '/icons/static_icons/large/marker_green.png';
  } else if (objPOI.largeIconLink !== void 0) {
    gm.largeIcon = objPOI.largeIconLink;
  } else {
    gm.largeIcon = '//' + window.location.host + '/icons/' + db + '/large/' + objPOI.largeIcon;
  }
  gm.id = id;
  if (gm.lat !== 0.0 && gm.lon !== 0.0) {
    addMarker(gm, key, id);
  }
};

addSubQuestionToMap = function(question, key) {
  var data;
  var i, j, opt, subQ;
  data = '';
  data += '<br/><strong> ' + question.text + ' </strong>';
  if (question.ans[key] === void 0) {
    data += '-';
  } else {
    data += question.ans[key];
  }
  if (question.hasSubquestions) {
    i = 0;
    while (i < question.options.length) {
      opt = question.options[i];
      if (question.action[opt] !== void 0) {
        subQ = question.action[opt];
        j = 0;
        while (j < subQ.length) {
          if (subQ[j].hideInPopup || subQ[j].hidden) {
            j++;
            continue;
          }
          data += addSubQuestionToMap(subQ[j], key);
          j++;
        }
      }
      i++;
    }
  }
  return data;
};

removePOIItem = function(id, location_id, level) {
  var key, objPOI;
  objPOI = getPOIByID(id);
  for (key in objPOI.instance.name) {
    if (objPOI.instance.locations[key][level] !== location_id) {
      j++;
      continue;
    }
    deletePOIMarker(id, key);
    display_data[key] = false;
  }
};


/**
	Removes all the POI instances if the given POI Type from the map
 */

removeAllPOIItems = function(id) {
  var current, key, objPOI;
  objPOI = getPOIByID(id);
  for (key in objPOI.instance.name) {
    deletePOIMarker(id, key);
    display_data[key] = false;
  }
  if (current === 'osm') {
    current = '';
  } else if (current === 'googlemaps') {
    current = '';
    showGoogleMap();
  }
};


/*
	check whether a key belongs to the POI with 'id' (passed onto the function)
 */

checkRowID = function(id, key) {
  var i;
  i = 0;
  while (i < POI[id].ques.forms.length) {
    if (POI[id].ques.forms[i].rowId === key) {
      return true;
    }
    i++;
  }
  return false;
};

disableDivs = function() {
  var divsLoaded;
  divsLoaded = false;
};


/**
	Goes through data and checks for data which satisfy the given criteria of location and level.
	It's row_id is added is to the array.
	When displaying data, only data whose row_id is present in the array will be displayed.
 */

addDisplayData = function(id, location_id, level) {
  var key, objPOI;
  objPOI = getPOIByID(id);
  for (key in objPOI.instance.locations) {
    if (objPOI.instance.locations[key][level] !== location_id && location_id !== '0ul0' || location_id === '0ul0' && objPOI.instance.locations[key] !== void 0 && (objPOI.instance.locations[key][level] !== null || objPOI.instance.locations[key][1] !== null || objPOI.instance.locations[key][2] !== null || objPOI.instance.locations[key][3] !== null || objPOI.instance.locations[key][level] !== '')) {
      i++;
      continue;
    }
    display_data[key] = true;
  }
  DisplayContent(id);
};

getAc = function(row_id, id) {
  var j, objPOI;
  objPOI = getPOIByID(id);
  j = 0;
  while (j < objPOI.ques.forms.length) {
    if (objPOI.ques.forms[j].rowId === row_id) {
      return j;
    }
    j++;
  }
};

renderSubQuestions = function(question) {
  var actions, opts, q, qn, sq, subQuestionHTML, t;
  subQuestionHTML = '';
  opts = question.options;
  actions = question.action;
  t = 0;
  while (t < opts.length) {
    if (actions[opts[t]] !== void 0) {
      sq = actions[opts[t]];
      q = 0;
      while (q < sq.length) {
        qn = sq[q];
        if (!qn.inVisible) {
          if (qn.text !== void 0) {
            subQuestionHTML += '<p>' + qn.text + '</p>';
          } else {
            subQuestionHTML += '<p>Other</p>';
          }
        }
        q++;
      }
    }
    t++;
  }
  return subQuestionHTML;
};

renderImage = function(question, formNo) {
  var imageText;
  imageText = '<tr class=\'alt3 ' + question.id + '_image hiddensq\'><td colspan=\'2\' ><img src=\'' + baseUrl + 'app/images/instance/' + formNo + '?id=' + question.id + '&random=' + Math.floor(Math.random() * 9999999 + 1) + '&key=' + pwrd + '&userid=' + userName + '\' alt=\'\'/></td></tr>';
  return imageText;
};

renderSq = function(question, formNo) {
  var actions, odd, opts, q, qn, showClass, sq, subQuestionHTML, t;
  subQuestionHTML = '';
  opts = question.options;
  actions = question.action;
  showClass = '';
  fc++;
  odd = '';
  if (fc % 2 === 0) {
    odd = '';
  }
  sqPadding = sqPadding + sqPaddingText;
  t = 0;
  while (t < opts.length) {
    if (actions[opts[t]] !== void 0) {
      sq = actions[opts[t]];
      if (question.ans[formNo] === opts[t]) {
        subQuestionHTML += '<tr class=\'parentQuestionCollapsed ' + question.id + '_subquestion ' + question.id + '_' + opts[t] + ' subquestion hiddensq pointer ' + odd + '\' onclick="showSq(\'' + question.id + '_subquestion_' + opts[t] + '\', \'' + question.id + '_' + opts[t] + '\')"><td>' + opts[t] + '</td><td class=\'selectedOption\'></td></tr>';
      } else {
        subQuestionHTML += '<tr class=\'parentQuestionCollapsed ' + question.id + '_subquestion ' + question.id + '_' + opts[t] + ' subquestion hiddensq pointer ' + odd + '\' onclick="showSq(\'' + question.id + '_subquestion_' + opts[t] + '\', \'' + question.id + '_' + opts[t] + '\')"><td colspan=\'2\'>' + opts[t] + '</td></tr>';
      }
      fc++;
      odd = '';
      q = 0;
      while (q < sq.length) {
        qn = sq[q];
        if (!qn.inVisible) {
          if (fc % 2 === 0) {
            odd = '';
          }
          subQuestionHTML += '<tr class=\'alt3 questionsq ' + ' ' + question.id + '_subquestion_' + opts[t] + ' ' + odd + ' subquestion hiddensq\' ><td>' + breakString(qn.text, 40) + '</td>';
          if (qn.ans[formNo] !== void 0 && qn.ans[formNo] !== '') {
            subQuestionHTML += '<td id=\'data' + qn.id + '\'>' + qn.ans[formNo] + '</td>';
          } else {
            subQuestionHTML += '<td id=\'data' + qn.id + '\'>-</td>';
          }
          subQuestionHTML += '</tr>';
          fc++;
          odd = '';
        }
        q++;
      }
    } else {
      if (question.ans[formNo] === opts[t]) {
        subQuestionHTML += '<tr class=\'' + question.id + '_subquestion ' + question.id + '_' + opts[t] + ' subquestion hiddensq pointer ' + odd + '\' onclick="showSq(\'' + question.id + '_subquestion_' + opts[t] + '\', \'' + question.id + '_' + opts[t] + '\')"><td style=\'padding-left:' + sqPadding + '\'>' + opts[t] + '</td><td class=\'selectedOption\'></td></tr>';
      } else {
        subQuestionHTML += '<tr class=\'' + question.id + '_subquestion ' + question.id + '_' + opts[t] + ' subquestion hiddensq pointer ' + odd + '\' onclick="showSq(\'' + question.id + '_subquestion_' + opts[t] + '\', \'' + question.id + '_' + opts[t] + '\')"><td style=\'padding-left:' + sqPadding + '\' colspan=\'2\'>' + opts[t] + '</td></tr>';
      }
    }
    t++;
  }
  return subQuestionHTML;
};

renderSubQuestionAns = function(question, formNo) {
  var actions, opts, q, qn, sq, subQuestionHTMLAns, t;
  subQuestionHTMLAns = '';
  opts = question.options;
  actions = question.action;
  t = 0;
  while (t < opts.length) {
    if (actions[opts[t]] !== void 0) {
      sq = actions[opts[t]];
      q = 0;
      while (q < sq.length) {
        qn = sq[q];
        if (!qn.inVisible) {
          if (qn.ans[formNo] !== void 0 && qn.ans[formNo] !== '') {
            subQuestionHTMLAns += '<p id=\'data' + qn.id + '\'>' + qn.ans[formNo] + '</p>';
          } else {
            subQuestionHTMLAns += '<p id=\'data' + qn.id + '\'>-</p>';
          }
        }
        q++;
      }
    }
    t++;
  }
  return subQuestionHTMLAns;
};

crossTabulate = function(id) {
  if (crossTabulationWindow !== void 0) {
    crossTabulationWindow.close();
  }
  crossTabulationWindow = PopupCenter('/tabulation.jsp', POI[id].name + ' crosstabulation', 800, 600);
  crossTabulationWindow.POI = POI[id];
  crossTabulationWindow.users = users_name;
  crossTabulationWindow.locations = locationLabels;
  crossTabulationWindow.focus();
};

$(function() {
  $('#conflict-dialog').dialog({
    open: function(event, ui) {
      $('a.ui-dialog-titlebar-close').show();
    },
    autoOpen: false,
    height: 420,
    width: 700,
    modal: true,
    position: 'center',
    buttons: {},
    close: function() {
      $(this).dialog('close');
    }
  });
});

//# sourceMappingURL=maps/content-old.js.map
